export default __webpack_public_path__ + "static/media/__start_guide_icon.0c2d59a0.svg";